import * as React from "react";
import { FileUploadSection } from "../../generic/fileUploadSection";
import { useState } from "react";
import {
  accClosureSR,
  accClosureValidate,
  GetDpDetails,
} from "../../../service/serviceRequest/srApiService";
import { config } from "../../../../config/domain";
import { StatusScreen } from "../../generic/statusScreen";
import { useQuery } from "../../../service/urlHelper";
import { AccounTypeRadio } from "./accountType";
import { DpTradingOptions } from "./dpTradingOption";
import { IListObj } from "../../../types/genericTypes";
import RadioButton from "../../../generic/radioButton";
import { OtpSection } from "../../generic/otpSection";
import EdModal from "../../../generic/edModal";
import { getAccData } from "../../../service/login/loginService";
import sampleSignature from "../../../../assets/images/Sample-signature-image.png";
import {
  base64toPDF,
  getEsignUrlJMWV2,
} from "../../../service/esign/esignService";
import {
  alphaNumExpWithSpace,
  alphaNumExp,
  alphabetExp,
} from "../../../utils/regex";
import InputField from "../../../generic/inputField";
import { GetNameDOBValidation } from "../../../service/generic/otherApi";
const transferTypes: Array<IListObj> = [
  { value: "Self Transfer", display: "Self Transfer" },
  { value: "Other Account Transfer", display: "Other Account Transfer" },
];
const checks = [
  { value: "There should not be any open order of MFSS" },
  { value: "Debit/Credit balances need to be settled before closure" },
  { value: "Account should not be closed already" },
  { value: "You need to ensure there are no securities in your Demat account" },
  { value: "You need to ensure that there are no open positions in your account"},
  { value: "You need to ensure that no stocks placed in collateral with EBL" },
  { value: "You should not have custody or NBFC POA account" },
  { value: "You should not have any running SIP" },
];

const errMsg: any = {
  acTyp: "Please select account Type",
  selectedDp: "Please select DP Id",
  mobileOtp: "Mobile OTP verification is required",
  emailOtp: "Email OTP verification is required",
  attachment: "Please upload document",
  reason: "Please select reason",
  reasonText: "Please provide reason to close account",
};

const successMsg: any = {
  HoldingValue: {
    err: " You need to ensure there are no securities in your Demat account ",
    msg: "To check holdings, please",
    link: config.rootUrl + "reports/consolidatedpholding",
  },
  OpenPosition_EQ_FO_CDS: {
    err: "You need to ensure that there are no open positions in your account ",
    msg: "To square off your positions, please",
    link: config.rootUrl + "?ottype=my-positions",
  },
  ValueOfStockLying_Coll_Hold_AccEBL: {
    err: "You need to ensure that no stocks placed in collateral with EBL ",
    msg: "To check pledge Holding, please",
    link: config.rootUrl + "reports/consolidatedpholding",
  },
  TradingLedgeBbalance: {
    err: "Debit/Credit balances need to be settled before closure ",
    msg: "To clear your balance, please",
    link: config.rootUrl + "reports/ledger/equity/snapshot",
  },
  MFSSOpenOrder: {
    err: "There should not be any open order of MFSS ",
    msg: "To check order status, please",
    link: config.rootUrl + "?ottype=order-status",
  },
  MF_SIP: {
    err: "You should not have any running SIP ",
    msg: "To check active SIPs, please",
    link: config.rootUrl + "?ottype=order-status",
  },
  EQTradingStatus: {
    err: "Your account is closed already ",
    msg: "",
    link: "",
  },
  CCTradingStatus: {
    err: "Your account is closed already ",
    msg: "",
    link: "",
  },
  DematAccountStatus: [
    {
      text: "Demat Account Status is ToBeClosed",
      err: "Your account is closed already ",
      msg: "",
      link: "",
    },
    {
      text: "Demat Account Status is Closed",
      err: "Your account is closed already ",
      msg: "",
      link: "",
    },
    {
      text: "Demat Account Status is Suspended for Debit/Credit",
      err: "Demat account status should not be suspended",
      msg: "",
      link: "",
    },
    {
      text: "Demat Account Status is Suspended for Debit",
      err: "Demat account status should not be suspended ",
      msg: "",
      link: "",
    },
    {
      text: "Demat Account Status is Suspended",
      err: "Demat account status should not be suspended ",
      msg: "",
      link: "",
    },
    {
      text: "Demat Account Status is Closed",
      err: "Your account is closed already ",
      msg: "",
      link: "",
    },
  ],
  ArbitrationStatus: {
    err: "Arbitration or IGRP or Appeal matter is open.",
    msg: "",
    link: "",
  },
  PMS_Custodian_Acc: {
    err: "You should not have custody or NBFC POA account",
    msg: "",
    link: "",
  },
  FundingAccount_NBFC: {
    err: "You should not have custody or NBFC POA account",
    msg: "",
    link: "",
  },
};

const AccountClosure: React.FC<any> = React.forwardRef(
  (props: any, ref: any) => {
    const source = useQuery().get("source");
    const [fileDetails, setFileDetails] = useState<any>([]);
    const [existingAccClosureSR, setExistingAccClosureSR] = useState(false);
    const [accType, setAccType] = useState<any>("trading+demat");
    const [selectedDp, setSelectedDp] = useState<string>("");
    const [reason, setReason] = useState<string>("");
    const [reasonText, setReasonText] = useState<string>("");
    const [selecteddpDetails, setSelecteddpDetails] = useState<any>();
    const [validationStr, setValidationStr] = useState<string>("");
    const [nameDOBValidation, setNameDOBValidation] = useState<any>();
    const [nameDOBMismatch, setNameDOBMismatch] = useState<any>();
    
    const [errors, setErrors] = useState<any>({
      selectedDp: "",
      reason: "",
      reasonText: "",
      mobileOtp: "",
      emailOtp: "",
      attachment: {
        cmr: "",
        sign: "",
      },
    });
    const [dpOptions, setDpOptions] = useState<IListObj[]>([]);
    const [dpDetails, setDpDetails] = useState<any>([]);
    const [jointHolderErrorMsg, setJointHolderErrorMsg] = useState<any>("");
    const [transferType, setTransferType] = useState<any>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [email, setEmail] = useState<any>({
      id: "",
      token: "",
    });
    const [mobile, setMobile] = useState<any>({
      id: "",
      token: "",
    });
    const [contentType, setContentType] = useState<string>("");
    const [validationErr, setValidationErr] = useState<any>();
    const [showOtp, setShowOtp] = useState<boolean>(false);
    const [invalidTime, setInvalidTime] = useState(false);
    const [DPType, setDPType] = useState<string>("");
    const [boId, setBoId] = useState<string>("");
    const [serviceReqList, setServiceReqList] = useState<any>();
    let storedList = window.sessionStorage.getItem("serviceReqList");
    

    React.useEffect(() => {
      getDobValidation();
      }, []);
    const getDobValidation = async()=>{
      props.setLoader(true);
      const nameDOBValidation = await GetNameDOBValidation();
      if(nameDOBValidation && nameDOBValidation.validationStatus) {
       setNameDOBValidation(nameDOBValidation.validationStatus)
       if(nameDOBValidation.result[0] && nameDOBValidation.result[0].data) {
           const result = nameDOBValidation?.result?.[0]?.data;
            const nameMsg = result?.nameMsg?.toLowerCase();
            const dobMsg = result?.dobMsg?.toLowerCase();
            if (nameMsg !== "matched with database" && dobMsg !== "matched with database") {
              setNameDOBMismatch("nameanddob");
            } else if (nameMsg === "matched with database" && dobMsg !== "matched with database") {
              setNameDOBMismatch("dob");
            } else if (nameMsg !== "matched with database" && dobMsg === "matched with database") {
              setNameDOBMismatch("name");
            } else {
              setNameDOBMismatch("");
            }
       }
      }
      props.setLoader(false);
    }
    React.useEffect(() => {
      setServiceReqList(storedList ? JSON.parse(storedList) : []);
      return () => {};
    }, [storedList]);
    React.useEffect(() => {
      checkExistingAccClosureSR();
      return () => {};
    }, []);

    React.useEffect(()=> {
      if(serviceReqList && serviceReqList?.length !== 0) {
         props.enableSubmit(false);
      }
      if(nameDOBMismatch === "name" || nameDOBMismatch === "dob" || nameDOBMismatch === "nameandob") {
        props.enableSubmit(false);
      }
    },[serviceReqList,nameDOBMismatch])

    React.useEffect(() => {
      if (selectedDp && accType !== "trading")
        setDPType(selectedDp.includes("IN") ? "NSDL" : "CDSL");
      if (
        dpDetails.length > 0 &&
        dpDetails[0].Linked_Demat_Accounts &&
        dpDetails[0].Linked_Demat_Accounts.length > 0
      ) {
        let selectedDpElement = dpDetails[0].Linked_Demat_Accounts.find(
          (ele: any) => {
            if (ele.BOID === selectedDp) return ele;
          }
        );

        if (selectedDpElement && selectedDpElement.DPHolderType) {
          if (selectedDpElement.DPHolderType === "Joint") {
            props.enableSubmit(false);
            setJointHolderErrorMsg(
              "It seems that the DP Account is a joint holder account. This request cannot be processed online."
            );
          } else {
            if (
              accType === "demat" &&
              selectedDpElement &&
              selectedDpElement.payOutDefault === 1
            ) {
              props.enableSubmit(false);
              setJointHolderErrorMsg(
                "Please get your default demat account changed to another before closure"
              );
            } else {
              setJointHolderErrorMsg("");
              setSelecteddpDetails(selectedDpElement);
            }
          }
        }
      }
    }, [accType, selectedDp]);

    React.useEffect(() => {}, [selectedDp]);

    React.useEffect(() => {
      if (showOtp) props.setBtnText("Confirm & E-Sign");
    }, [showOtp]);

    const validate = (dpData?: any, selectedDpVal?: any, acc?: any) => {
      console.log("dpData", dpData, dpDetails);

      let selDpDet = dpData ? dpData : dpDetails;
      let selDp = selectedDpVal ? selectedDpVal : selectedDp;
      let selAccType = acc ? acc : accType;

      if (selDpDet.length > 0) {
        const reqObj = {
          pan: selDpDet.length > 0 ? selDpDet[0].PANNo : "",
          dpId: selDp,
          accTyp: getAccData("accTyp"),
          trdUpd: selAccType.toLowerCase().includes("trading"),
          dpUpd: selAccType.toLowerCase().includes("demat"),
        };
        if (selAccType === "trading") {
          reqObj.dpId = "";
          setEmail({
            token: "",
            id: selDpDet[0].ToEmailList,
          });
          setMobile({
            token: "",
            id: selDpDet[0].MobileList,
          });
        } else {
          setEmail({
            token: "",
            id:
              selecteddpDetails && selecteddpDetails.H1_EmailId
                ? selecteddpDetails.H1_EmailId
                : selDpDet && selDpDet[0].ToEmailList,
          });
          setMobile({
            token: "",
            id:
              selecteddpDetails && selecteddpDetails.H1_Mobile
                ? selecteddpDetails.H1_Mobile
                : selDpDet && selDpDet[0].MobileList,
          });
        }

        if (
          (selAccType.toLowerCase().includes("demat") && selDp) ||
          selAccType === "trading"
        ) {
          props.setParLoader(true);
          accClosureValidate(reqObj)
            .then((res) => {
              props.setParLoader(false);
              if (res.data) {
                setValidationStr(res.data.value);
                const valData = JSON.parse(res.data.value)[0];
                if (
                  valData.ValidationRemarks &&
                  valData.ValidationRemarks.length > 0
                ) {
                  let err: any = {};
                  valData.ValidationRemarks.map((x: any) => {
                    err[`${x.validation_key}`] = x.validation_message;
                  });
                  setValidationErr(err);
                }
                props.setParLoader(false);
              } else if (res.error.errCd === "SR0004") {
                props.rightDiv(rightSideDiv());
                setExistingAccClosureSR(false);
                props.showFooter(true);
                props.setBtnText("Generate OTP");
                setInvalidTime(true);
                props.enableSubmit(false);
                props.setLoader(false);
              } else {
                openSRErrorPopup();
              }
            })
            .catch((err) => {
              openSRErrorPopup();
            });
        }
      }

      // }
      else if (selecteddpDetails) {
        setEmail({
          token: "",
          id:
            selecteddpDetails && selecteddpDetails.H1_EmailId
              ? selecteddpDetails.H1_EmailId
              : dpDetails && dpDetails[0].ToEmailList,
        });
        setMobile({
          token: "",
          id:
            selecteddpDetails && selecteddpDetails.H1_Mobile
              ? selecteddpDetails.H1_Mobile
              : dpDetails && dpDetails[0].MobileList,
        });
      }
    };
    
    const getDpDetails = () => {
      props.setParLoader(true);
      GetDpDetails()
        .then((res) => {
          props.setParLoader(false);
          if (res.data) {
            const dpData = JSON.parse(res.data.value);
            setDpDetails(dpData);
            setDpDetailsOptions(dpData[0].Linked_Demat_Accounts, dpData);
          } else {
            openSRErrorPopup();
          }
        })
        .catch((err) => {
          openSRErrorPopup();
        });
    };
    const setDpDetailsOptions = (dematDet: any, dpData?: any) => {
      let dpOptions: any = [];

      dematDet.forEach((ele: any) => {
        if (dpOptions.length === 0) {
          dpOptions.push({
            display: "Select DP Details",
            value: "",
          });
        }
        dpOptions.push({
          display: ele.BOID,
          value: ele.BOID,
          ...ele,
        });
      });
      if (dpOptions.length > 2) {
        setDpOptions(dpOptions);
        props.setParLoader(false);
      } else if (dpOptions.length === 2) {
        setDpOptions(dpOptions);
        setSelectedDp(dpOptions[1].value);
        validate(dpData, dpOptions[1].value);
      } else if (dpOptions.length === 0) {
        props.setParLoader(false);
      }
      else if(dpOptions.length === 0){
        props.setParLoader(false);
      }
    };

    const checkExistingAccClosureSR = async () => {
      try {
        props.setParLoader(true);
        props.rightDiv(rightSideDiv());
        getDpDetails();
        props.showFooter(true);
        props.enableSubmit(true);
        props.setBtnText("Generate OTP");
        props.setParLoader(false);
      } catch (error) {
        openSRErrorPopup();
      }
    };

    const openSRErrorPopup = () => {
      props.setParLoader(false);
      props.onSubmit("accClosure", {
        headerText: "There was some problem in raising service request. Please try again later.",
      });
    };

    const openExistSrPopup = () => {
      props.setLoader(false);
      props.onSubmit("accClosure", {
        headerText: "You have an active service request",
        content: "You already have an active service request. Once it is updated, you will be able to raise new request.",
      });
    };

    const rightSideDiv = () => {
      return (
        <div className="nomination acctClosureWrap space-mt-2">
          <div className="">
            <button
              type="button"
              className="head"
              onClick={() => {
                setShowModal(true);
                setContentType("CheckList");
              }}
            >
              Check list for Account Closure
            </button>
          </div>
        </div>
      );
    };
    
    const handleSubmit = (file: any, type: string) => {
      if (file && file.docFile && file.base64Data) {
        var actualbase64Data = file.base64Data.split(",");
        setFileDetails([
          ...fileDetails,
          {
            nm: file.docFile,
            data: actualbase64Data[1],
            docType: type,
            qcFlag: true,
          },
        ]);
        if (
          [
            ...fileDetails,
            {
              nm: file.docFile,
              data: actualbase64Data[1],
              docType: type,
              qcFlag: true,
            },
          ].length === 2
        ) {
          setErrors({
            ...errors,
            attachment: {
              cmr: "",
              sign: "",
            },
          });
        } else if (
          [
            ...fileDetails,
            {
              nm: file.docFile,
              data: actualbase64Data[1],
              docType: type,
              qcFlag: true,
            },
          ].length === 1
        ) {
          setErrors({
            ...errors,
            attachment: {
              cmr: type === "CMR" ? "" : errors.attachment.cmr,
              sign: type === "CMR" ? errors.attachment.sign : "",
            },
          });
        }
      } else {
        let files = fileDetails;
        const index = fileDetails.findIndex((x: any) => x.docType === type);
        files.splice(index, 1);
        setFileDetails(files);
      }
    };

    const submitReq = () => {
      
      let address: any = accType.includes("demat")
        ? {
            addr1: selecteddpDetails.DP_Correspondence_Address.Addr1,
            addr2: selecteddpDetails.DP_Correspondence_Address.Addr2,
            addr3: selecteddpDetails.DP_Correspondence_Address.Addr3,
            addr4: selecteddpDetails.DP_Correspondence_Address.Addr4,
            city: selecteddpDetails.DP_Correspondence_Address.City,
            state: selecteddpDetails.DP_Correspondence_Address.State,
            pin: selecteddpDetails.DP_Correspondence_Address.Pincode,
          }
        : {
            addr1: dpDetails.length > 0 ? dpDetails[0].Addr1 : "-----",
            addr2: dpDetails.length > 0 ? dpDetails[0].Addr2 : "-----",
            addr3: dpDetails.length > 0 ? dpDetails[0].Addr3 : "-----",
            addr4: dpDetails.length > 0 ? dpDetails[0].Addr4 : "-----",
            city: dpDetails.length > 0 ? dpDetails[0].City : "",
            state: dpDetails.length > 0 ? dpDetails[0].CState : "",
            pin: dpDetails.length > 0 ? dpDetails[0].PinCode : "",
          };

      Object.keys(address).map((k) => {
        if (k.includes("addr")) {
          if (address[k].length < 5) {
            let str = "";
            for (let i = 0; i < 5 - address[k].length; i++) {
              str += "-";
            }
            address[k] += str;
          }
        } else {
          if (!address[k]) address[k] = "";
        }
      });

      let reqObj = {
        acTyp:
          getAccData("accTyp") && getAccData("accTyp") === "COMEQ"
            ? "EQ"
            : getAccData("accTyp"),
        dpId: selectedDp,
        mobToken: mobile.token,
        mobile: mobile.id,
        emailToken: email.token,
        email: email.id,
        attachments: fileDetails,
        trdUpd: accType.toLowerCase().includes("trading"),
        dpUpd: accType.toLowerCase().includes("demat"),
        validationReport: validationStr,
        closeRsn: reason === "Others" ? reasonText : reason,
        reqTyp: accType,
        address,
        closureType:
          transferType && transferType === "Self Transfer"
            ? "Balance Transfer"
            : "Nil Holding",
        assignedTeamCode: accType.toLowerCase().includes("demat") ? 12 : 4,
        assignedTeamName: accType.toLowerCase().includes("demat")
          ? "DPTeam"
          : "OPS Helpdesk Team",
        callTypId: 74,
        subTypId: 732,
        coLoginId: dpDetails.length ? dpDetails[0].COLoginId : "",
        eqLoginId: dpDetails.length ? dpDetails[0].EQLoginId : "",
        clntTyp: dpDetails.length ? dpDetails[0].Client_Type : "",
        targetBoId: boId,
      };

      props.setParLoader(true);
      accClosureSR(reqObj)
        .then(async (res) => {
          if (res && res.data && res.data.data) {
            base64toPDF(res.data.data);
            const esign = await getEsignUrlJMWV2(
              res.data.data,
              res.data.srId,
              "accClosure"
            );
            if (!esign) {
              openSRErrorPopup();
            }
          } else if (res && res.error && res.error.errCd === "SR0005" ) {
            openExistSrPopup();
          } else {
            openSRErrorPopup();
          }
        })
        .catch((err) => {
          openSRErrorPopup();
        });
    };

    const formValidation = () => {
      try {
        let err: any = {};
        let validation = true;
        const required = ["reason"];

        if (accType.includes("demat") && dpOptions.length > 0) {
          required.push("selectedDp");
        }

        if (reason === "Others") {
          required.push("reasonText");
        }
        if (showOtp) {
          required.push("mobileOtp", "emailOtp");
        }
        if (
          typeof validationErr === "object" &&
          Object.keys(validationErr).length === 1 &&
          validationErr.hasOwnProperty("HoldingValue")
        ) {
          required.push("transferType");
          if (transferType === "Self Transfer") {
            required.push("attachment");
            required.push("boId");
          }
        }
        const formData: any = {
          selectedDp,
          reason,
          reasonText,
          mobileOtp: mobile.token,
          emailOtp: email.token,
          transferType,
          attachment: fileDetails,
          boId: boId,
        };
        required.map((x: any) => {
          if (x === "attachment") {
            if (formData[x].length !== 2) {
              if (formData[x].length === 0)
                err[x] = {
                  cmr: errMsg[x],
                  sign: errMsg[x],
                };
              else if (formData[x].length === 1)
                err[x] = {
                  cmr: formData[x][0].docType === "CMR" ? "" : errMsg[x],
                  sign: formData[x][0].docType === "CMR" ? errMsg[x] : "",
                };
              validation = false;
            }
          } else {
            if (
              formData[x] === "" ||
              formData[x] === null ||
              formData[x] === undefined
            ) {
              err[x] = errMsg[x];
              validation = false;
            }
            if (x === "reasonText") {
              if (!alphaNumExpWithSpace.test(formData[x])) {
                err[x] = "Special characters are not allowed like < , > etc.";
                validation = false;
              }
            } else if (x === "boId") {
              if (!formData[x]) {
                err[x] = "DP Id is required";
                validation = false;
              } else if (alphabetExp.test(formData[x])) {
                err[x] = "Demat Id should not contain all alphabets";
                validation = false;
              } else if (!alphaNumExp.test(formData[x])) {
                err[x] = "Please enter a valid DP Id";
                validation = false;
              } else if (formData[x].length !== 16) {
                err[x] = "Demat Id should be of length 16";
                validation = false;
              }
            }
          }
        });

        setErrors(err);
        return validation;
      } catch (e) {
        // console.log(e);
      }
    };

    const modalData = (cType: string) => {
      switch (cType) {
        case "CheckList":
          return (
            <>
              <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup consent_popup innerModal acctClosureCheckList">
                <div className="modal-content">
                  <div
                    className="modal-body scrollableModal"
                    id="custom_scrollBar"
                  >
                    <div>
                      <a
                        role="button"
                        onClick={() => {
                          setShowModal(false);
                        }}
                        title="Close"
                        className="cancel sign-cross-button"
                      >
                        <i className="edel-icon-close"></i>
                      </a>
                    </div>
                    <div className="finalScreen panAdharLink digiLocker acctClosure">
                      <div className="center_items">
                        <p className="field-head text-center">
                          Account Closure Check List
                        </p>
                      </div>
                      <div className="reactivateSteps">
                        <ul>
                          {checks &&
                            checks.length > 0 &&
                            checks.map((c) => {
                              return (
                                <li className="bullet_lists">
                                  <div>
                                    <div className="link_arrow">
                                      <i className="edel-icon-right-arrow"></i>
                                    </div>
                                  </div>
                                  <p>{c.value}</p>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                      <div className="acctClosrCheckListBtn">
                        <a
                          role="button"
                          onClick={() => {
                            setShowModal(false);
                          }}
                        >
                          OK
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        case "Signature":
          return (
            <>
              <div className="modal-dialog modal-dialog-centered common-modal-deisgn finalPopup consent_popup innerModal">
                <div className="modal-content">
                  <div
                    className="modal-body scrollableModal"
                    id="custom_scrollBar"
                  >
                    <div className="acctClosureCloseBtn">
                      <a
                        role="button"
                        onClick={() => {
                          setShowModal(false);
                          setContentType("");
                        }}
                        title="Close"
                        className="cancel sign-cross-button"
                      >
                        <i className="edel-icon-close"></i>
                      </a>
                    </div>
                    <div className="finalScreen consentPopup pinError">
                      <img src={sampleSignature} height="350px" width="100%" />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        default:
          return <></>;
      }
    };

    React.useImperativeHandle(ref, () => ({
      submitData(val: any) {
        if (formValidation()) {
          if (!(mobile.token && email.token)) {
            setShowOtp(true);
            props.srDropDown(true);
            props.setBtnText("Confirm & E-Sign");
          } else {
            submitReq();
          }
        }
      },
    }));

    React.useEffect(() => {
      const _validationErr =
        typeof validationErr === "object"
          ? Object.keys(validationErr).length === 1
            ? validationErr.hasOwnProperty("HoldingValue")
              ? transferType === "Self Transfer"
              : false
            : false
          : true;
      if (
        Object.values(errors)
          .map((x: any) => {
            return (
              x === "" ||
              x === null ||
              x === undefined ||
              (typeof x === "object" && !x.cmr && !x.sign)
            );
          })
          .every((x) => x === true) &&
        _validationErr
      ) {
        props.enableSubmit(true);
      } else {
        props.enableSubmit(false);
      }
    }, [errors, validationErr]);

    const hasFreeHoldings = () => {
      return (
        typeof validationErr === "object" &&
        Object.keys(validationErr).length === 1 &&
        validationErr.hasOwnProperty("HoldingValue")
      );
    };
    const allowedStatuses = ['Returned',"Processed","RejectedByHO","Rejected","Processed", "Rejected-EsignNotSubmitted", "Closed", "Completed"];
    const shouldBlockClosure = serviceReqList?.length > 0 && serviceReqList?.some(
      (request:any) =>
        !allowedStatuses.includes((request.RequestStatus?.trim().replace(/\s*-\s*/, "-")  || ""))
    );
    return (
      <>
        {(nameDOBValidation && nameDOBValidation == "success") ? 
         (
           !shouldBlockClosure ?
          <>
            {existingAccClosureSR && serviceReqList?.length === 0 ? (
              <StatusScreen
                headerText="Account Closure in Process"
                desc="Another Account Closure request is under process. Please raise any new requests only once those are processed."
                status="Pending"
              />
            ) : (
              <div className="nomination acctClosureWrap">
                {!invalidTime ? (
                  dpDetails.length > 0 && (
                    <>
                      <AccounTypeRadio
                        setAccountType={(val: any) => {
                          console.log("val", val);
                          if (dpDetails[0].Linked_Demat_Accounts.length !== 0) {
                            if (val === "trading") validate("", "", val);
                            else if (selectedDp) validate("", "", val);
                          } else if (val === "trading") validate("", "", val);

                          setAccType(val);
                          setTransferType("");
                          setFileDetails([]);
                          setBoId("");
                          setReason("");
                          setReasonText("");
                          setValidationErr(undefined);
                        }}
                        disabled={showOtp || mobile.token || email.token}
                        onlyTrading={
                          dpDetails[0].Linked_Demat_Accounts.length === 0
                            ? 1
                            : 0
                        }
                      />

                      <DpTradingOptions
                        dpOptions={dpOptions}
                        selectedAcc={accType}
                        selectedDp={selectedDp}
                        setSelectedDp={(val: any) => {
                          setSelectedDp(val);
                          setValidationErr(undefined);
                          validate("", val);
                        }}
                        errorMsg={jointHolderErrorMsg}
                        accountCode={
                          dpDetails.length ? dpDetails[0].AccountCode : ""
                        }
                        reason={reason}
                        setReason={setReason}
                        setErrors={setErrors}
                        errors={errors}
                        disabled={showOtp || mobile.token || email.token}
                        jointHolderErrorMsg={jointHolderErrorMsg}
                      />

                      {reason === "Others" && (
                        <div className="custom--row nomineeAddr tradingAccnt">
                          <div className="custom-col-100 noLeftPAdding">
                            <div className="otherReason">
                              <textarea
                                rows={3}
                                cols={2}
                                onChange={(e) => {
                                  setReasonText(e.target.value);
                                  setErrors({ ...errors, reasonText: "" });
                                }}
                                maxLength={DPType === "NSDL" ? 50 : 100}
                                onBlur={(e) => {
                                  
                                }}
                                placeholder="Enter closure reason"
                                disabled={
                                  showOtp || mobile.token || email.token
                                }
                              />
                              <p>
                                {reasonText.length}/
                                {DPType === "NSDL" ? 50 : 100}
                              </p>
                            </div>

                            {errors.reasonText && errors.reasonText !== "" && (
                              <p className="help_text red">
                                {errors.reasonText}
                              </p>
                            )}
                          </div>
                        </div>
                      )}

                      {
                        <>
                          {!jointHolderErrorMsg && (
                            <>
                              {hasFreeHoldings() && (
                                <div className="holding acctClosureHolding">
                                  <div className="msg">
                                    <p className="blue-text">
                                      {" "}
                                      We have found that you have free holdings
                                      in your account. In order to transfer this
                                      to your other account, Please click on
                                      self-transfer option below
                                    </p>
                                  </div>
                                  <div className="CheckboxWrap">
                                    <div className="space-mt-3">
                                      <h6>Free Holdings</h6>
                                    </div>
                                    <div className="payment-radio nominationRadio space-mb-1">
                                      <div className="display-flex tradeDemat">
                                        <div className="radioBtn_wrap">
                                          <RadioButton
                                            list={transferTypes[0]}
                                            name="transferTypeNomin"
                                            onChange={() => {
                                              setTransferType(
                                                transferTypes[0].value
                                              );
                                              setErrors({
                                                ...errors,
                                                transferType: "",
                                              });
                                            }}
                                            disabled={
                                              showOtp ||
                                              mobile.token ||
                                              email.token
                                            }
                                            selected={transferType}
                                          />
                                        </div>

                                        <div className="radioBtn_wrap acctTranferRadioBtn">
                                          <RadioButton
                                            list={transferTypes[1]}
                                            name="transferTypeNomin"
                                            onChange={() => {
                                              setTransferType(
                                                transferTypes[1].value
                                              );
                                              setErrors({
                                                ...errors,
                                                transferType: "",
                                              });
                                              setBoId("");
                                            }}
                                            selected={transferType}
                                            disabled={
                                              showOtp ||
                                              mobile.token ||
                                              email.token
                                            }
                                          />

                                          <div>
                                            <div className="special-text-wrap">
                                              <p className="special-text">
                                                <div className="redCircleBg">
                                                  <i className="edel-icon-faqs"></i>
                                                </div>
                                                <span className="special-text__tooltip">
                                                  Transfer the stocks offline
                                                </span>
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        {errors.transferType &&
                                          errors.transferType !== "" && (
                                            <p className="help_text red">
                                              {errors.transferType}
                                            </p>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                  {transferType === "Self Transfer" && (
                                    <div
                                      className={
                                        "custom--row tradingAccnt dpTradingAcctWrap" +
                                        (errors.boId ? " space-mb-0" : "")
                                      }
                                    >
                                      <div className="custom-col space-mt-1">
                                        <label className="input-label">
                                          DP Id
                                        </label>
                                        <InputField
                                          maxLength={16}
                                          type="text"
                                          required
                                          getValue
                                          onChange={(val: any) => {
                                            setBoId(val);
                                            setErrors({ ...errors, boId: "" });
                                          }}
                                          onBlur={(error: any) => {
                                            
                                          }}
                                          placeholder="DP Id"
                                          onMouseOut={() => {}}
                                          defaultValue={boId}
                                          errorText={errors.boId}
                                          autoComplete="off"
                                          disabled={
                                            showOtp ||
                                            mobile.token ||
                                            email.token
                                          }
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {transferType === "Self Transfer" && (
                                    <>
                                      <div>
                                        <div className="custom-row">
                                          <div className="acctTranferRadioBtn acctTranferRadioBtnUpload">
                                            <div className="acctTranferRadioBtn-block">
                                              <label className="incomeMsg bold-text">
                                                Upload Digital Signed CMR of
                                                Target Account
                                              </label>
                                              <div>
                                                <div className="special-text-wrap">
                                                  <p className="special-text">
                                                    <div className="redCircleBg">
                                                      <i className="edel-icon-faqs"></i>
                                                    </div>
                                                    <span className="special-text__tooltip">
                                                      To get your CMR copy of
                                                      Target account, contact
                                                      the Depository participant
                                                      with whom you have a demat
                                                      account where you wish to
                                                      transfer the shares from
                                                      your Nuvama account to
                                                      that demat account with
                                                      another Depository
                                                      participant (Target
                                                      account). To transfer
                                                      shares via online account
                                                      closure cum transfer
                                                      process, submit the
                                                      closure form along with
                                                      CMR copy of your account
                                                      held with another
                                                      Depository participant
                                                      (Target Account).
                                                    </span>
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <p className="acc-text">
                                            Scanned copy of CMR Account
                                          </p>
                                          <FileUploadSection
                                            fileType={[
                                              "tif",
                                              "tiff",
                                              "pdf",
                                              "jpg",
                                              "jpeg",
                                            ]}
                                            onSubmit={(data: any) =>
                                              handleSubmit(data, "CMR")
                                            }
                                            disableCross={
                                              showOtp ||
                                              mobile.token ||
                                              email.token
                                            }
                                          />
                                          {errors.attachment &&
                                            errors.attachment.cmr &&
                                            errors.attachment.cmr !== "" && (
                                              <p className="help_text red">
                                                {errors.attachment.cmr}
                                              </p>
                                            )}
                                        </div>
                                        <div className="custom-row profilePhoto space-mt-2">
                                          <label className="incomeMsg bold-text">
                                            Signature
                                          </label>
                                          <div className="space-between-aligned subLink">
                                            <p className="acc-text">
                                              Photo copy of your Signature
                                            </p>
                                            <div className="special-text-wrap topTooltip">
                                              <a
                                                className="link special-text"
                                                onClick={() => {
                                                  setShowModal(true);
                                                  setContentType("Signature");
                                                }}
                                              >
                                                View Sample
                                                <span className="special-text__tooltip">
                                                  <img
                                                    src={sampleSignature}
                                                    height="89px"
                                                    width="150px"
                                                  />
                                                </span>
                                              </a>
                                            </div>
                                          </div>

                                          <FileUploadSection
                                            fileType={[
                                              "tif",
                                              "tiff",
                                              "pdf",
                                              "jpg",
                                              "jpeg",
                                            ]}
                                            onSubmit={(data: any) =>
                                              handleSubmit(data, "Signature")
                                            }
                                            crop={true}
                                            disableCross={
                                              showOtp ||
                                              mobile.token ||
                                              email.token
                                            }
                                          />
                                          {errors.attachment &&
                                            errors.attachment.sign &&
                                            errors.attachment.sign !== "" && (
                                              <p className="help_text red">
                                                {errors.attachment.sign}
                                              </p>
                                            )}
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  {transferType ===
                                    "Other Account Transfer" && (
                                    <p className="help_text red">
                                      {" "}
                                      Please transfer the stocks offine & raise
                                      request after successful transfer
                                    </p>
                                  )}
                                </div>
                              )}
                              {showOtp && (!mobile.token || !email.token) && (
                                <div className="custom--row nomineeAddr tradingAccnt">
                                  <div className="form-field custom-col noLeftPAdding">
                                    {!mobile.token && (
                                      <OtpSection
                                        details={{
                                          mobileNo: mobile.id,
                                          type: "mobileNo",
                                          srType: "Online Closure Request",
                                          acTyp: getAccData("accTyp"),
                                          srAcType:
                                            accType === "trading+demat"
                                              ? "Trading And Demat"
                                              : accType === "trading"
                                              ? "Trading"
                                              : "Demat",
                                          dpId:
                                            accType === "trading"
                                              ? ""
                                              : selectedDp,
                                        }}
                                        otpVerified={(token: any) => {
                                          setMobile({ ...mobile, token });
                                          setErrors({
                                            ...errors,
                                            mobileOtp: "",
                                          });
                                        }}
                                        verifyDisabled={
                                          errors.mobileNo || errors.emailId
                                        }
                                        setLoader={(val: boolean) => {
                                          props.setParLoader(val);
                                        }}
                                      />
                                    )}
                                    {errors.mobileOtp &&
                                      errors.mobileOtp !== "" && (
                                        <p className="help_text red">
                                          {errors.mobileOtp}
                                        </p>
                                      )}
                                  </div>

                                  {!email.token && (
                                    <div className="form-field custom-col noLeftPAdding space-mb-0">
                                      <OtpSection
                                        details={{
                                          emailId: email.id,
                                          type: "emailId",
                                          srType: "Online Closure Request",
                                          acTyp: getAccData("accTyp"),
                                          srAcType:
                                            accType === "trading+demat"
                                              ? "Trading And Demat"
                                              : accType === "trading"
                                              ? "Trading"
                                              : "Demat",
                                          dpId:
                                            accType === "trading"
                                              ? ""
                                              : selectedDp,
                                        }}
                                        otpVerified={(token: any) => {
                                          setEmail({ ...email, token });
                                          setErrors({
                                            ...errors,
                                            emailOtp: "",
                                          });
                                        }}
                                        verifyDisabled={
                                          errors.mobileNo || errors.emailId
                                        }
                                        setLoader={(val: boolean) => {
                                          props.setParLoader(val);
                                        }}
                                      />
                                      {errors.emailOtp &&
                                        errors.emailOtp !== "" && (
                                          <p className="help_text red">
                                            {errors.emailOtp}
                                          </p>
                                        )}
                                    </div>
                                  )}
                                </div>
                              )}
                              {typeof validationErr === "object" ? (
                                Object.keys(validationErr).length > 1 ? (
                                  <ul className="errlistWrap">
                                    {Object.entries(validationErr).map(
                                      (val: any) => {
                                        return (
                                          successMsg[val[0]] && (
                                            <li className="errlist">
                                              <p className="help-text red">
                                                {successMsg[val[0]] &&
                                                successMsg[val[0]].err &&
                                                successMsg[val[0]].err !==
                                                  "" ? (
                                                  <span>
                                                    {successMsg[val[0]].err}
                                                  </span>
                                                ) : (
                                                  <span>{val[1]} </span>
                                                )}
                                                {successMsg[val[0]].msg && (
                                                  <>
                                                    <span>-</span>
                                                    <span>
                                                      {" "}
                                                      {successMsg[val[0]].msg}
                                                    </span>
                                                  </>
                                                )}{" "}
                                                {successMsg[val[0]].link && (
                                                  <a
                                                    className="head"
                                                    href={`${
                                                      successMsg[val[0]].link
                                                    }`}
                                                  >
                                                    Click here
                                                  </a>
                                                )}
                                              </p>
                                            </li>
                                          )
                                        );
                                      }
                                    )}
                                  </ul>
                                ) : Object.keys(validationErr)[0] ===
                                  "HoldingValue" ? (
                                  <></>
                                ) : (
                                  <ul className="errlistWrap">
                                    <li className="errlist">
                                      <p className="help-text red">
                                        <span>
                                          {Object.values(validationErr)[0]}{" "}
                                        </span>
                                        {successMsg[
                                          Object.keys(validationErr)[0]
                                        ].msg &&
                                          successMsg[
                                            Object.keys(validationErr)[0]
                                          ].msg.trim() && (
                                            <>
                                              <span>-</span>
                                              <span>
                                                {" "}
                                                {
                                                  successMsg[
                                                    Object.keys(
                                                      validationErr
                                                    )[0]
                                                  ].msg
                                                }
                                              </span>
                                            </>
                                          )}{" "}
                                        {successMsg[
                                          Object.keys(validationErr)[0]
                                        ].link && (
                                          <a
                                            className="head"
                                            href={`${
                                              successMsg[
                                                Object.keys(validationErr)[0]
                                              ].link
                                            }`}
                                          >
                                            Click here
                                          </a>
                                        )}
                                      </p>
                                    </li>
                                  </ul>
                                )
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      }
                    </>
                  )
                ) : (
                  <>
                    <p className="help-text red">
                      <span>Requests cannot be raised after 3:30 PM</span>
                    </p>
                  </>
                )}
              </div>
            )}

            <EdModal
              show={showModal}
              close={() => {}}
              children={modalData(contentType)}
              modalClsNm={"modal-Sr"}
            />
          </> : <p className="help-text red line-ht-standard">You have an ongoing service request. During this time, you cannot initiate account closure request.</p>
          ) : nameDOBMismatch == "nameanddob"? <p className="small-text small-text--subHead red">You are not permitted to raise request as the Name and DOB in your trading account are not matching with PAN. Please connect with your Relationship Manager or contact our nearest branch for the same.</p>  
          : nameDOBMismatch == "name"? <p className="small-text small-text--subHead red">You are not permitted to raise request as Name in your trading account is not matching with PAN. Please connect with your Relationship Manager or contact our nearest branch for the same.</p> 
                : nameDOBMismatch == "dob"? <p className="small-text small-text--subHead red">You are not permitted to raise request as DOB in your trading account is not matching with PAN. Please connect with your Relationship Manager or contact our nearest branch for the same.</p> : ""
         
        }
        <EdModal
              show={showModal}
              close={() => {}}
              children={modalData(contentType)}
              modalClsNm={"modal-Sr"}
            />
      </>
    );
  }
);

export default AccountClosure;
